var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.showDialog,"persistent":"","dark":"","fullscreen":"","transition":"fade-transition"}},[_c('div',{staticClass:"d-flex align-center justify-center overlay h100"},[_c('ContentSwitcher',{ref:"mediaContainer",staticClass:"w100 h100",attrs:{"items":_vm.mediaItems,"show-arrows":_vm.$b.d,"show-dots":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('Media',_vm._g({ref:"media",staticClass:"img w100",class:{
						scale1: _vm.scale == 1,
						scale2: _vm.scale == 2,
						'pt-60': _vm.$b.m,
						'pt-80': _vm.$b.t,
					},style:(_vm.containerStyle),attrs:{"src":!item._multiple ? item : item.big,"width":"100%","scale-down":"","loader":"","aspect-ratio":"1","video-props":{
						class: 'text-center',
						videoAttrs: {
							controls: true,
							width: _vm.$b.d ? 'auto' : '100%',
							height: _vm.$b.d ? '100%' : 'auto',
						},
					},"youtube-video-props":{
						iframeAttrs: {
							frameborder: 0,
						},
					}}},_vm.getHandlers(item)))]}}]),model:{value:(_vm.currentIndex),callback:function ($$v) {_vm.currentIndex=$$v},expression:"currentIndex"}}),_c('Button',{staticClass:"place-up",attrs:{"absolute":"","top":"","right":"","icon":"","x-large":"","dark":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-close")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }